import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { JobInvoicing } from '~hooks/useJob/models';

interface RequestedEquipmentTypeColumnProps {
  job: JobInvoicing;
  sx?: SxProps<Theme>;
}

export default function RequestedEquipmentTypeColumn({
  job,
  sx,
}: RequestedEquipmentTypeColumnProps) {
  const { requestedEquipmentTypeName } = job;

  return (
    <Box sx={sx}>
      <OverflowAwareText>{requestedEquipmentTypeName ?? '-'}</OverflowAwareText>
    </Box>
  );
}
